// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Cache from "../data/Cache.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Patch from "common/src/Patch.bs.js";
import * as React from "react";
import * as Config from "common/src/Config.bs.js";
import * as Global from "common/src/Global.bs.js";
import * as Select from "../components/Select.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as RankGroup from "common/src/RankGroup.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import Format from "date-fns/format";
import CircularProgress from "@mui/material/CircularProgress";

function StatsConfig$GamesCount(Props) {
  var aperture = Props.aperture;
  var commonT = Translation.useT(/* Common */0);
  var data = Cache.useStats2(aperture.queue);
  var tmp;
  if (data !== undefined) {
    var lastUpdated = new Date(Global.f(data.lastUpdated) * 1000);
    tmp = React.createElement("div", {
          className: "text-[11px] leading-[15px] text-white2 text-right font-roboto"
        }, React.createElement("div", undefined, T.humanReadableCount(data.totalEntries) + " " + commonT("comps analyzed")), React.createElement("div", undefined, commonT("Updated") + " " + Format(lastUpdated, "MMM d ha")));
  } else {
    tmp = React.createElement(CircularProgress, {
          size: 22
        });
  }
  return React.createElement("div", {
              className: "w-[120px] flex justify-center"
            }, tmp);
}

var GamesCount = {
  make: StatsConfig$GamesCount
};

function StatsConfig$RankGroupSelect(Props) {
  var commonT = Translation.useT(/* Common */0);
  var aperture = ApertureCtx.useValue(undefined);
  var setAperture = ApertureCtx.useSetter(undefined);
  return React.createElement(Select.make, {
              options: [
                [
                  /* GM */4,
                  commonT("GM+")
                ],
                [
                  /* Master */0,
                  commonT("Master+")
                ],
                [
                  /* Diamond */1,
                  commonT("Diamond+")
                ],
                [
                  /* Gold */2,
                  commonT("Emerald+")
                ],
                [
                  /* All */3,
                  commonT("Platinum+")
                ]
              ],
              value: aperture.rankGroup,
              setValue: (function (rankGroup) {
                  return Curry._1(setAperture, (function (aperture) {
                                return {
                                        patch: aperture.patch,
                                        rankGroup: rankGroup,
                                        gameType: aperture.gameType,
                                        queue: aperture.queue
                                      };
                              }));
                }),
              toKey: RankGroup.toId,
              fromKey: (function (v) {
                  return Belt_Option.getExn(RankGroup.fromId(v));
                }),
              classes: {
                select: "w-20 text-[14px] py-[3px] !pr-5",
                icon: "my-[2px] w-[20px] h-[20px]"
              }
            });
}

var RankGroupSelect = {
  make: StatsConfig$RankGroupSelect
};

function StatsConfig$QueueSelect(Props) {
  var t = Translation.useT(/* Common */0);
  var aperture = ApertureCtx.useValue(undefined);
  var setAperture = ApertureCtx.useSetter(undefined);
  return React.createElement(Select.make, {
              options: [
                [
                  1100,
                  t("Ranked")
                ],
                [
                  1160,
                  t("Double Up")
                ],
                [
                  6100,
                  t("Set #").replace("#", "15") + " Revival"
                ]
              ],
              value: aperture.queue,
              setValue: (function (queue) {
                  return Curry._1(setAperture, (function (aperture) {
                                return {
                                        patch: aperture.patch,
                                        rankGroup: aperture.rankGroup,
                                        gameType: aperture.gameType,
                                        queue: queue
                                      };
                              }));
                }),
              toKey: (function (prim) {
                  return String(prim);
                }),
              fromKey: (function (v) {
                  return Belt_Option.getExn(Belt_Int.fromString(v));
                }),
              classes: {
                select: "w-[66px] text-[14px] py-[3px] !pr-5",
                icon: "my-[2px] w-[20px] h-[20px]"
              }
            });
}

var QueueSelect = {
  make: StatsConfig$QueueSelect
};

function StatsConfig$PatchSelect(Props) {
  Translation.useT(/* Common */0);
  var aperture = ApertureCtx.useValue(undefined);
  var setAperture = ApertureCtx.useSetter(undefined);
  return React.createElement(Select.make, {
              options: Belt_Array.concat([[
                      Patch.latest,
                      "Last 2 Days"
                    ]], Belt_Array.map(Config.allPatches, (function (p) {
                          return [
                                  /* Patch */{
                                    _0: p
                                  },
                                  Patch.render(p)
                                ];
                        }))),
              value: aperture.patch,
              setValue: (function (patch) {
                  return Curry._1(setAperture, (function (aperture) {
                                return {
                                        patch: patch,
                                        rankGroup: aperture.rankGroup,
                                        gameType: aperture.gameType,
                                        queue: aperture.queue
                                      };
                              }));
                }),
              toKey: Patch.toApiUrl,
              fromKey: Patch.fromApiUrl,
              classes: {
                select: "w-12 text-[14px] py-[3px] !pr-5",
                icon: "my-[2px] w-[20px] h-[20px]"
              }
            });
}

var PatchSelect = {
  make: StatsConfig$PatchSelect
};

function StatsConfig(Props) {
  var children = Props.children;
  Translation.useT(/* Common */0);
  var aperture = ApertureCtx.useValue(undefined);
  ApertureCtx.useSetter(undefined);
  return React.createElement("div", {
              className: "flex flex-col sm:flex-row items-center gap-1 sm:gap-4 bg-bg rounded px-4 mb-6"
            }, React.createElement("div", {
                  className: "py-2 flex justify-center items-center gap-2"
                }, React.createElement(StatsConfig$QueueSelect, {}), React.createElement(StatsConfig$RankGroupSelect, {}), React.createElement(StatsConfig$PatchSelect, {})), React.createElement("div", {
                  className: "flex items-center gap-2"
                }, React.createElement(StatsConfig$GamesCount, {
                      aperture: aperture
                    }), Belt_Option.getWithDefault(children, null)));
}

function StatsConfig$Context(Props) {
  var children = Props.children;
  var aperture = ApertureCtx.useValue(undefined);
  var set = TftSet.use(undefined);
  var match = aperture.queue;
  if (match !== 6000) {
    if (match !== 6100) {
      if (match !== 6110) {
        return children;
      } else if (set === 140 || set === 14) {
        return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set101 */15, children, undefined));
      } else {
        return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set56 */12, children, undefined));
      }
    } else if (set === 170 || set === 17) {
      return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set151 */16, children, undefined));
    } else if (set === 150 || set === 15) {
      return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set76 */13, children, undefined));
    } else {
      return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set46 */14, children, undefined));
    }
  } else {
    return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set36 */11, children, undefined));
  }
}

var Context = {
  make: StatsConfig$Context
};

var make = StatsConfig;

export {
  GamesCount ,
  RankGroupSelect ,
  QueueSelect ,
  PatchSelect ,
  make ,
  Context ,
  
}
/* T Not a pure module */
